<template>
    <div id="review-detail-content">
        dfszdfz
    </div>
</template>

<script>
    export default {
        name: 'vs-review-detail-content',
        data() {
            return {

            }
        }
    }
</script>